import { GET_ROLES } from "../types/roleType";

const initialState = {
    roles: []
};

const roleReducer = (state = initialState, action) => {
    const { payload, type } = action;
    switch (type) {
        case GET_ROLES:
            return {
                ...state,
                roles: payload
            };
        default:
            return state;
    }
};

export default roleReducer;
